import { render, staticRenderFns } from "./TypeBenefitEdit.vue?vue&type=template&id=73ab9e24&"
import script from "./TypeBenefitEdit.vue?vue&type=script&lang=js&"
export * from "./TypeBenefitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports